// extracted by mini-css-extract-plugin
module.exports = {"root":"AboutTheAuthors_root__L66px","content":"AboutTheAuthors_content__3GM43","label":"AboutTheAuthors_label__2SWZW"};